import InnerComponent from '@Components/Production/MRPV2/ViewMrpV2';
import orgContainer from '@Components/AppContainer';

const ViewMrpV2 = () => ((orgContainer(InnerComponent)));
export default ViewMrpV2;
